import React from "react";
import { Button, Card, Select, Tag, Typography } from "@douyinfe/semi-ui";
import { AiReport } from "../../../api/aiCoach";
import { PeriodPreset } from "../constants";
import { radius, sp } from "../styles";

const { Title, Text } = Typography;

export interface SaleOption {
  id: number;
  name: string;
  mobile: string;
}

interface Props {
  isAdmin: boolean;
  saleOptions: SaleOption[];
  selectedSaleId?: number;
  onSelectSale: (id: number) => void;
  period: PeriodPreset;
  onChangePeriod: (p: PeriodPreset) => void;
  report: AiReport | null;
  periodLabel: string;
  isProcessing: boolean;
  disableGenerate: boolean;
  onGenerate: () => void;
}

const ReportHeader: React.FC<Props> = ({
  isAdmin,
  saleOptions,
  selectedSaleId,
  onSelectSale,
  period,
  onChangePeriod,
  report,
  periodLabel,
  isProcessing,
  disableGenerate,
  onGenerate,
}) => {
  const status = report?.status;
  const ready = status === "ready";

  return (
    <Card
      style={{
        marginBottom: sp.lg,
        borderRadius: radius.md,
        background: "linear-gradient(135deg, var(--semi-color-bg-1) 0%, var(--semi-color-bg-2) 100%)",
      }}
      bodyStyle={{ padding: sp.lg }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: sp.md, flexWrap: "wrap" }}>
        <div style={{ flex: 1, minWidth: 220 }}>
          <div style={{ display: "flex", alignItems: "center", gap: sp.sm }}>
            <Title heading={3} style={{ margin: 0 }}>
              {isAdmin ? "AI 智能分析" : "我的周报"}
            </Title>
            {status && (
              <Tag
                size="large"
                color={status === "ready" ? "green" : status === "failed" ? "red" : "blue"}
              >
                {status === "ready" ? "已生成" : status === "failed" ? "失败" : "生成中"}
              </Tag>
            )}
          </div>
          <Text type="tertiary" style={{ marginTop: sp.xs, display: "block" }}>
            {periodLabel}
          </Text>
        </div>

        {isAdmin && (
          <div style={{ width: 280 }}>
            <Select
              value={selectedSaleId}
              placeholder="选择销售"
              style={{ width: "100%" }}
              filter
              onChange={(v) => onSelectSale(v as number)}
            >
              {saleOptions.map((s) => (
                <Select.Option key={s.id} value={s.id} label={s.name}>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span>{s.name}</span>
                    <Text type="tertiary" size="small">
                      {s.mobile}
                    </Text>
                  </div>
                </Select.Option>
              ))}
            </Select>
          </div>
        )}

        <div style={{ width: 140 }}>
          <Select
            value={period}
            style={{ width: "100%" }}
            onChange={(v) => onChangePeriod(v as PeriodPreset)}
          >
            <Select.Option value="thisWeek">本周</Select.Option>
            <Select.Option value="lastWeek">上周</Select.Option>
          </Select>
        </div>

        <Button
          theme="solid"
          type="primary"
          size="large"
          loading={isProcessing}
          disabled={disableGenerate}
          onClick={onGenerate}
        >
          {ready ? "重新生成" : "生成本周报告"}
        </Button>
      </div>
    </Card>
  );
};

export default ReportHeader;
